import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GroupService } from '../../services/group.service';
import { PlayerService } from '../../services/player.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 's18-stripe',
  templateUrl: './stripe.component.html',
  styleUrls: ['./stripe.component.scss']
})
export class StripeComponent implements OnInit {

  client_code: string;
  error: string;
  connecting: boolean = false;
  connected: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private groupService: GroupService,
    private playerService: PlayerService,
    private localStorage: LocalStorageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.client_code = params["code"];
      this.error = params["error"];
      if (this.client_code) {
        this.connecting = true;
        this.groupService
          .requestClientAuthentication(
            this.client_code,
            this.playerService.getLoggedInPlayerInfo().player_id.toString(),
            this.localStorage.get("stripe_group_id")
          )
          .subscribe(resp => {
            this.connecting = false;
            var response = JSON.parse(resp.d).response;
            if (response.status === 'success') {
              this.connected = true;
            } else {
              console.log(response);
            }

          })

      }
    })
  }

  backToGroupSettings() {
    let group_id = this.localStorage.get("stripe_group_id");
    this.localStorage.set("stripe_group_id", "");
    this.router.navigateByUrl('/group/console/' + group_id + '/0')
  }

}
